export class ListInventoryEnvironmentsResponse {
    'environments';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "environments",
            "baseName": "environments",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListInventoryEnvironmentsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
